// Espaces partenaires : libellés et conversions partagés par les pages Espaces et Planning.
export const KIND_LABELS = {
    home_first: "Bannière home (position 1)",
    home_third: "Bannière home (position 3)",
    listing_card: "Carte dans les listes produits",
    brand_banner: "Bannière page marque",
    sponsored_product: "Sponsoring fiche produit",
    product_page_ad: "Publicité fiche produit",
    blog_banner: "Bannière blog",
    blog_insert: "Encart blog",
    blog_article: "Article blog dédié",
    newsletter_dedicated: "Newsletter dédiée",
    newsletter_banner: "Bannière newsletter",
    newsletter_insert: "Encart newsletter",
    push_notification: "Notification push",
    story_comparator: "Story comparateur",
    story_direct: "Story lien direct",
};

// AUTO_PUBLISH : emplacements mis en ligne automatiquement à la validation ; les autres sont diffusés à la main par TRC.
export const AUTO_PUBLISH = ["home_first", "home_third", "listing_card", "product_page_ad", "blog_banner", "blog_insert", "push_notification", "sponsored_product"];

// SITE_PREVIEW : emplacements visibles en aperçu sur le vrai site (?displayPreview).
export const SITE_PREVIEW = ["home_first", "home_third", "listing_card", "product_page_ad"];

// parisParts : date (AAAA-MM-JJ) et heure (HH:MM) à Paris d'un instant ISO.
export function parisParts(iso) {
    const d = new Date(iso);
    if (isNaN(d)) return { date: "", time: "" };
    const p = Object.fromEntries(new Intl.DateTimeFormat("fr-FR", { timeZone: "Europe/Paris", year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", hour12: false }).formatToParts(d).map((x) => [x.type, x.value]));
    return { date: `${p.year}-${p.month}-${p.day}`, time: `${p.hour === "24" ? "00" : p.hour}:${p.minute}` };
}

// parisISO : « 2026-11-17 » + « 18:00 » (heure de Paris) → instant ISO UTC ; saisie invalide ⇒ null.
export function parisISO(date, time) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date || ""); const h = /^(\d{2}):(\d{2})$/.exec(time || "");
    if (!m || !h) return null;
    const guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +h[1], +h[2]);
    const seen = parisParts(new Date(guess).toISOString());
    const [sy, sm, sd] = seen.date.split("-").map(Number); const [sh, smin] = seen.time.split(":").map(Number);
    const offset = Date.UTC(sy, sm - 1, sd, sh, smin) - guess;
    return new Date(guess - offset).toISOString();
}

// defaultPushSend : mardi 18 h (Paris) de la première semaine réservée.
export function defaultPushSend(weeks) {
    const w = [...(weeks || [])].sort()[0];
    if (!w) return { date: "", time: "18:00" };
    const d = new Date(`${w}T12:00:00Z`);
    d.setUTCDate(d.getUTCDate() + 1);
    return { date: d.toISOString().slice(0, 10), time: "18:00" };
}

export const CHANNEL_LABELS = { site: "Site", blog: "Blog", newsletter: "Newsletter", app: "App TRC", instagram: "Instagram" };

// euros : centimes → « 1 234,50 € » (withSymbol = false ⇒ « 1234,50 » pour un champ de saisie).
export function euros(cents, withSymbol = true) {
    const v = (Number(cents) || 0) / 100;
    if (!withSymbol) return v.toFixed(2).replace(".", ",");
    return v.toLocaleString("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: v % 1 ? 2 : 0 });
}

// parseEuros : « 1 234,5 » → 123450 centimes ; vide, texte, négatif ou séparateur ambigu (« 1.200 ») ⇒ null.
export function parseEuros(text) {
    const t = String(text || "").replace(/[\s\u00a0€]/g, "");
    if (!/^\d+([.,]\d{1,2})?$/.test(t)) return null;
    return Math.round(parseFloat(t.replace(",", ".")) * 100);
}

// mondayOf : lundi (YYYY-MM-DD, heure locale) de la semaine de d.
export function mondayOf(d = new Date()) {
    const x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    x.setDate(x.getDate() - ((x.getDay() + 6) % 7));
    return ymd(x);
}

export function addWeeks(week, n) {
    const [y, m, d] = week.split("-").map(Number);
    return ymd(new Date(y, m - 1, d + 7 * n));
}

function ymd(x) {
    const p = (n) => String(n).padStart(2, "0");
    return `${x.getFullYear()}-${p(x.getMonth() + 1)}-${p(x.getDate())}`;
}

// weekLabel : « 09/11 ».
export function weekLabel(week) {
    const [, m, d] = week.split("-");
    return `${d}/${m}`;
}

// statsView : chiffres d'une réservation (en direct ou bilan) — mêmes calculs que l'espace partenaire.
export function statsView(st) {
    const n = (v) => (Number(v) || 0).toLocaleString("fr-FR").replace(/[\u202f\u00a0]/g, " ");
    const pct = (clicks, base) => `${(base ? (clicks * 100) / base : 0).toFixed(1).replace(".", ",")} %`;
    const r = st && st.report;
    const push = st && st.kind === "push_notification";
    const keys = push ? ["st_sent", "st_devices", "st_opens", "st_openRate"] : ["st_impressions", "st_viewers", "st_clicks", "st_ctr"];
    if (!r) return { push, keys, totals: null, weeks: [] };
    const label = (w) => { const [, m, d] = String(w || "").slice(0, 10).split("-"); return d && m ? `${d}/${m}` : String(w || ""); };
    return {
        push, keys,
        totals: [n(r.impressions), n(st.viewers), n(r.clicks), pct(r.clicks, r.impressions)],
        weeks: (r.weeks || []).map((w) => ({ week: label(w.week), cells: [n(w.impressions), n(w.viewers), n(w.clicks), pct(w.clicks, w.impressions)] })),
    };
}
